import { InvestorType } from '../../login/redux/types';

export const investorTypeThresholds: {
    type: InvestorType;
    title: string;
    list: { text: string; tooltip?: string }[];
}[] = [
    {
        type: 'Individual Accredited',
        title: 'Select this if you meet either one of the following criteria:',
        list: [
            {
                text: 'Net personal assets of at least S$2 million (or its equivalent in a foreign currency)',
                tooltip:
                    'For example, bank deposits, investment holdings in securities, funds, derivatives contracts, properties, and more.',
            },
            {
                text: 'Net financial assets (net of any related liabilities) exceeding S$1 million in value (or its equivalent in a foreign currency)',
                tooltip:
                    'For example, bank deposits, investment holdings in securities, funds, derivatives contracts, and more.',
            },
            {
                text: 'Total income of at least S$300,000 (or equivalent) for the last 12 months',
            },
        ],
    },
    {
        type: 'Corporate Accredited',
        title: 'Select this if the corporation or trust you represent meets either one of the following criteria:',
        list: [
            {
                text: 'A corporation with net assets exceeding S$10 million (or its equivalent in a foreign currency)',
            },
            {
                text: 'A corporation where the entire share capital is owned by one or more persons, all of whom are accredited investors',
                tooltip:
                    'Criteria for individual accredited investors are shown under the Individual Accredited Investor tab',
            },
            {
                text: 'A trust where all beneficiaries are accredited investors',
                tooltip:
                    'Criteria for individual accredited investors are shown under the Individual Accredited Investor tab',
            },
            {
                text: 'A trust where the subject matter of which exceeds S$10 million (or its equivalent in a foreign currency)',
                // tooltip:
                // 'For example, bank statements, central depository statement, brokerage statement, distributor statement, and more.',
            },
            {
                text: 'A trust where all settlers are accredited investors, and have all powers of investment of the trust',
                tooltip:
                    'Supporting documents include trust documents, or declaration from professional trustee, bank statements, broker statements, etc',
            },
        ],
    },
    {
        type: 'Institutional',
        title: 'Select this if you are representing either one of these entities (non-exhaustive list):',
        list: [
            {
                text: 'A government entity',
            },
            {
                text: 'An entity wholly owned by the government',
            },
            {
                text: 'A licensed / regulated entity',
            },
            {
                text: 'A collective investment scheme or pension fund',
            },
            {
                text: 'An entity where the entire share capital is owned by institutional investors.',
            },
        ],
    },
];

export const AIQualificationStatus: {
    type: InvestorType;
    list: string[];
    doc: {
        status: string;
        title?: string;
        list: { tooltip?: string; title: string; type: string; mandatory?: boolean }[];
    }[];
}[] = [
    {
        type: 'Individual Accredited',
        list: [
            'Net personal assets of at least S$2 million (or its equivalent in a foreign currency)',
            'Net financial assets (net of any related liabilities) exceeding S$1 million in value (or its equivalent in a foreign currency)',
            'Total income of at least S$300,000 (or equivalent) for the last 12 months',
        ],
        doc: [
            {
                status: 'Net personal assets of at least S$2 million (or its equivalent in a foreign currency)',
                title: 'To allow our compliance team to validate your AI status, please provide any combination of the following, preferably dated in the last 3 months:',
                list: [
                    {
                        title: 'Savings & Deposits',
                        type: 'Savings & Deposits',
                        tooltip: `
                            <p>Supporting documents may include:
                            <ol className="list-disc">
                                <li className="list-item list-inside py-1"> Latest bank statements</li>
                            </ol>`,
                    },
                    {
                        title: 'Investments in securities, derivatives, spot forex contracts, etc',
                        type: 'Investments in Securities, derivatives, spot forex contracts, etc',
                        tooltip: `
                            <p>Supporting documents may include:</p>
                            <ul className="list-disc">
                                <li className="list-item list-inside">Bank Statement</li>
                                <li className="list-item list-inside">Central Depository (CDP) Statement</li>
                                <li className="list-item list-inside">Brokerage Statement</li>
                                <li className="list-item list-inside">Distributor Statement</li>
                                <li className="list-item list-inside">Any other statements showing the investment holdings</li>
                            </ul>
                        `,
                    },
                    {
                        title: 'Fixed Assets',
                        type: 'Fixed Assets',
                        tooltip: `
                            <p>Supporting documents may include:</p>
                            <ul className="list-disc">
                                <li className="list-item list-inside">Property or land title deed</li>
                                <li className="list-item list-inside">Valuation report</li>
                                <li className="list-item list-inside">Mortgage loan</li>
                            </ul>`,
                    },
                ],
            },
            {
                status: 'Net financial assets (net of any related liabilities) exceeding S$1 million in value (or its equivalent in a foreign currency)',
                title: 'To allow our compliance team to validate your AI status, please provide any combination of the following, preferably dated in the last 3 months:',
                list: [
                    {
                        title: 'Savings & Deposits',
                        type: 'Savings & Deposits',
                        tooltip: `
                        <p>Supporting documents may include:
                        <ol className="list-disc">
                            <li className="list-item list-inside"> Latest bank statements</li>
                        </ol>`,
                    },
                    {
                        title: 'Investments in securities, derivatives, spot forex contracts, etc',
                        type: 'Investments in Securities, derivatives, spot forex contracts, etc',
                        tooltip: `
                        <p>Supporting documents may include:</p>
                        <ol className="list-disc">
                            <li className="list-item list-inside">Bank Statement</li>
                            <li className="list-item list-inside">Central Depository (CDP) Statement</li>
                            <li className="list-item list-inside">Brokerage Statement</li>
                            <li className="list-item list-inside">Distributor Statement</li>
                            <li className="list-item list-inside">Any other statements showing the investment holdings</li>
                        </ol>
                    `,
                    },
                ],
            },
            {
                status: 'Total income of at least S$300,000 (or equivalent) for the last 12 months',
                list: [
                    {
                        title: 'Income',
                        type: 'Income',
                        tooltip: `
                            <p>Supporting documents may include:</p>
                            <ol className="list-disc">
                                <li className="list-item list-inside">Salary slip for the last 3 months;</li>
                                <li className="list-item list-inside">Income tax form (i.e. IRAS Notice of Assessment) declaring personal income not less than S$300,000 (or overseas tax authorities’ returns); or</li>
                                <li className="list-item list-inside">Letter from employer certifying individual’s income in the preceding 12 months.</li>
                            </ol>
                        `,
                    },
                ],
            },
        ],
    },
    {
        type: 'Corporate Accredited',
        list: [
            'A corporation with net assets exceeding S$10 million (or its equivalent in a foreign currency)',
            'A corporation where the entire share capital is owned by one or more persons, all of whom are accredited investors',
            'A trust where all beneficiaries are accredited investors',
            'A trust where the subject matter of which exceeds S$10 million (or its equivalent in a foreign currency)',
            'A trust where all settlers are accredited investors, and have all powers of investment of the trust',
        ],
        doc: [
            {
                status: 'A corporation with net assets exceeding S$10 million (or its equivalent in a foreign currency)',
                title: `To allow our compliance officer to validate your company's AI status, please provide either one of the documents from the list below:`,
                list: [
                    {
                        title: 'Balance Sheet',
                        type: 'Balance Sheet',
                        tooltip: `
                            <p>Supporting documents may include:</p>
                            <ul className="list-disc">
                                <li className="list-item list-inside">The corporation’s most recent audited balance sheet; or</li>
                                <li className="list-item list-inside">If the company is not required to be audited, an unaudited balance sheet certified as true by the Director (dated within the last 12 months)</li>
                            </ul>
                        `,
                    },
                ],
            },
            {
                status: 'A corporation where the entire share capital is owned by one or more persons, all of whom are accredited investors',
                title: 'To allow our compliance team to validate your AI status, please provide any combination of the following, preferably dated in the last 3 months:',
                list: [
                    {
                        title: 'Company Shareholding Chart',
                        type: 'Company Shareholding Chart',
                        mandatory: true,
                        // tooltip: `
                        //     <p>Supporting documents may include:
                        //     <ol className="list-disc">
                        //         <li className="list-item list-inside py-1"> Latest bank statements</li>
                        //     </ol>`,
                    },
                    {
                        title: 'Savings & Deposits',
                        type: 'Savings & Deposits',
                        tooltip: `
                            <p>Supporting documents may include:
                            <ol className="list-disc">
                                <li className="list-item list-inside py-1"> Latest bank statements</li>
                            </ol>`,
                    },
                    {
                        title: 'Investments in securities, derivatives, spot forex contracts, etc',
                        type: 'Investments in Securities, derivatives, spot forex contracts, etc',
                        tooltip: `
                            <p>Supporting documents may include:</p>
                            <ul className="list-disc">
                                <li className="list-item list-inside">Bank Statement</li>
                                <li className="list-item list-inside">Central Depository (CDP) Statement</li>
                                <li className="list-item list-inside">Brokerage Statement</li>
                                <li className="list-item list-inside">Distributor Statement</li>
                                <li className="list-item list-inside">Any other statements showing the investment holdings</li>
                            </ul>
                        `,
                    },
                    {
                        title: 'Fixed Assets',
                        type: 'Fixed Assets',
                        tooltip: `
                            <p>Supporting documents may include:</p>
                            <ul className="list-disc">
                                <li className="list-item list-inside">Property or land title deed</li>
                                <li className="list-item list-inside">Valuation report</li>
                                <li className="list-item list-inside">Mortgage loan</li>
                            </ul>`,
                    },
                    {
                        title: 'Income',
                        type: 'Income',
                        tooltip: `
                            <p>Supporting documents may include:</p>
                            <ol className="list-disc">
                                <li className="list-item list-inside">Salary slip for the last 3 months;</li>
                                <li className="list-item list-inside">Income tax form (i.e. IRAS Notice of Assessment) declaring personal income not less than S$300,000 (or overseas tax authorities’ returns); or</li>
                                <li className="list-item list-inside">Letter from employer certifying individual’s income in the preceding 12 months.</li>
                            </ol>
                        `,
                    },
                ],
            },
            {
                status: 'A trust where all beneficiaries are accredited investors',
                title: 'To allow our compliance team to validate your AI status, please provide any combination of the following, preferably dated in the last 3 months:',
                list: [
                    {
                        title: 'Savings & Deposits',
                        type: 'Savings & Deposits',
                        tooltip: `
                            <p>Supporting documents may include:
                            <ol className="list-disc">
                                <li className="list-item list-inside py-1"> Latest bank statements</li>
                            </ol>`,
                    },
                    {
                        title: 'Investments in securities, derivatives, spot forex contracts, etc',
                        type: 'Investments in Securities, derivatives, spot forex contracts, etc',
                        tooltip: `
                            <p>Supporting documents may include:</p>
                            <ul className="list-disc">
                                <li className="list-item list-inside">Bank Statement</li>
                                <li className="list-item list-inside">Central Depository (CDP) Statement</li>
                                <li className="list-item list-inside">Brokerage Statement</li>
                                <li className="list-item list-inside">Distributor Statement</li>
                                <li className="list-item list-inside">Any other statements showing the investment holdings</li>
                            </ul>
                        `,
                    },
                    {
                        title: 'Fixed Assets',
                        type: 'Fixed Assets',
                        tooltip: `
                            <p>Supporting documents may include:</p>
                            <ul className="list-disc">
                                <li className="list-item list-inside">Property or land title deed</li>
                                <li className="list-item list-inside">Valuation report</li>
                                <li className="list-item list-inside">Mortgage loan</li>
                            </ul>`,
                    },
                    {
                        title: 'Income',
                        type: 'Income',
                        tooltip: `
                            <p>Supporting documents may include:</p>
                            <ol className="list-disc">
                                <li className="list-item list-inside">Salary slip for the last 3 months;</li>
                                <li className="list-item list-inside">Income tax form (i.e. IRAS Notice of Assessment) declaring personal income not less than S$300,000 (or overseas tax authorities’ returns); or</li>
                                <li className="list-item list-inside">Letter from employer certifying individual’s income in the preceding 12 months.</li>
                            </ol>
                        `,
                    },
                ],
            },
            {
                status: 'A trust where the subject matter of which exceeds S$10 million (or its equivalent in a foreign currency)',
                title: 'To allow our compliance team to validate your AI status, please provide any combination of the following, preferably dated in the last 3 months:',
                list: [
                    {
                        title: 'Savings & Deposits',
                        type: 'Savings & Deposits',
                        tooltip: `
                            <p>Supporting documents may include:
                            <ol className="list-disc">
                                <li className="list-item list-inside"> Latest bank statements</li>
                            </ol>`,
                    },
                    {
                        title: 'Investments in securities, derivatives, spot forex contracts, etc',
                        type: 'Investments in Securities, derivatives, spot forex contracts, etc',
                        tooltip: `
                            <p>Supporting documents may include:</p>
                            <ol className="list-disc">
                                <li className="list-item list-inside">Bank Statement</li>
                                <li className="list-item list-inside">Central Depository (CDP) Statement</li>
                                <li className="list-item list-inside">Brokerage Statement</li>
                                <li className="list-item list-inside">Distributor Statement</li>
                                <li className="list-item list-inside">Any other statements showing the investment holdings</li>
                            </ol>
                        `,
                    },
                ],
            },
            {
                status: 'A trust where all settlers are accredited investors, and have all powers of investment of the trust',
                title: 'To allow our compliance team to validate your AI status, please provide any combination of the following, preferably dated in the last 3 months:',
                list: [
                    {
                        title: 'Savings & Deposits',
                        type: 'Savings & Deposits',
                        tooltip: `
                            <p>Supporting documents may include:
                            <ol className="list-disc">
                                <li className="list-item list-inside py-1"> Latest bank statements</li>
                            </ol>
                        `,
                    },
                    {
                        title: 'Investments in securities, derivatives, spot forex contracts, etc',
                        type: 'Investments in Securities, derivatives, spot forex contracts, etc',
                        tooltip: `
                            <p>Supporting documents may include:</p>
                            <ul className="list-disc">
                                <li className="list-item list-inside">Bank Statement</li>
                                <li className="list-item list-inside">Central Depository (CDP) Statement</li>
                                <li className="list-item list-inside">Brokerage Statement</li>
                                <li className="list-item list-inside">Distributor Statement</li>
                                <li className="list-item list-inside">Any other statements showing the investment holdings</li>
                            </ul>
                        `,
                    },
                    {
                        title: 'Fixed Assets',
                        type: 'Fixed Assets',
                        tooltip: `
                            <p>Supporting documents may include:</p>
                            <ul className="list-disc">
                                <li className="list-item list-inside">Property or land title deed</li>
                                <li className="list-item list-inside">Valuation report</li>
                                <li className="list-item list-inside">Mortgage loan</li>
                            </ul>
                        `,
                    },
                    {
                        title: 'Income',
                        type: 'Income',
                        tooltip: `
                            <p>Supporting documents may include:</p>
                            <ol className="list-disc">
                                <li className="list-item list-inside">Salary slip for the last 3 months;</li>
                                <li className="list-item list-inside">Income tax form (i.e. IRAS Notice of Assessment) declaring personal income not less than S$300,000 (or overseas tax authorities’ returns); or</li>
                                <li className="list-item list-inside">Letter from employer certifying individual’s income in the preceding 12 months.</li>
                            </ol>
                        `,
                    },
                ],
            },
        ],
    },
];
